// extracted by mini-css-extract-plugin
export default {"title":"ResourceSection_title__ogK0q","count":"ResourceSection_count__6ceEg","skeleton":"ResourceSection_skeleton__M1vCu","pagination":"ResourceSection_pagination__1jL2V"};